import { createElement, forwardRef } from 'react'

import { splitProps } from '../helpers.mjs';
import { getLevelStyle } from '../patterns/level.mjs';
import { styled } from './factory.mjs';

export const Level = /* @__PURE__ */ forwardRef(function Level(props, ref) {
  const [patternProps, restProps] = splitProps(props, ["align","pinCenter"])

const styleProps = getLevelStyle(patternProps)
const mergedProps = { ref, ...styleProps, ...restProps }

return createElement(styled.div, mergedProps)
  })